export default "/images/arrow.svg?f7f8fef762d40c40d44ca92e805ed8ef";